import {Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {NavigationStart, Router} from "@angular/router";
import {filter, Subject, Subscription} from "rxjs";

@Component({
  selector: 'app-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.scss']
})
export class MobileMenuComponent implements OnInit, OnDestroy {
  @Input() isOpenMobileMenu = false
  @Output() isOpenMobileMenuChange: EventEmitter<boolean> = new EventEmitter<boolean>()

  routeNavigationStart: Subscription | undefined

  constructor(
    private router: Router
  ) {
  }

  ngOnInit() {
    this.routeNavigationStart = this.router.events.pipe(
      filter((event) => event instanceof NavigationStart)).subscribe({
      next: () => {
        this.closeMobileMenu()
      }
    })
  }

  ngOnDestroy() {
    this.routeNavigationStart?.unsubscribe()
  }

  closeMobileMenu() {
    this.isOpenMobileMenu = false
    this.isOpenMobileMenuChange.emit(this.isOpenMobileMenu)
  }

}
